import React from "react";
import { Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import { Link } from "react-router-dom";
import CustomersTable from "../../components/Tables/CustomersTable";
import withPermissions from "../../components/WithPermissions";
import ManagementPageHero from "../../components/ManagementPageHero";
class Customers extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const {userPermissions} = this.props;
    const userHasNewCustomerPermission = userPermissions.includes('new customer');
    return (
      <div
        className="management-page"
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            <PageHeader
                HeaderText="Müşteriler"
                Breadcrumb={[
                  {name: "Müşteriler", navigate: ""},

                ]}
            />
            <ManagementPageHero
              eyebrow="MÜŞTERİ YÖNETİMİ"
              title="Müşterilerinizi kolayca yönetin"
              description="İletişim bilgilerine, araçlarına ve servis geçmişlerine tek noktadan ulaşın."
              actionTo={userHasNewCustomerPermission ? "/customer-add" : null}
              actionLabel="Yeni müşteri"
            />
            <div className="row clearfix">
              <div className="col-lg-12 col-md-12">
                <div className="card planned_task management-list-card">
                  <div className="header">
                    <h2>Müşteriler</h2>
                    {userHasNewCustomerPermission ? (
                        <Dropdown as="ul" className="header-dropdown">
                          <Dropdown.Toggle
                              variant="success"
                              as="li"
                              id="dropdown-basic"
                          >
                            <i className="icon-plus text-success p-1 ml-1"></i>
                            <Dropdown.Menu
                                as="ul"
                                className="dropdown-menu dropdown-menu-right"
                            >
                              <li>
                                <Link to="customer-add">Yeni Müşteri/Tedarikçi</Link>
                              </li>

                            </Dropdown.Menu>
                          </Dropdown.Toggle>
                        </Dropdown>
                    ) : ""}
                  </div>
                  <div className="body">
                    <CustomersTable>

                    </CustomersTable>
                  </div>
                </div>
              </div>
            </div>
            <style>
              {`
                #dropdown-basic::after {
                    display: none;                                                     
                }
              `}
            </style>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ioTReducer}) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(connect(mapStateToProps, {})(Customers));
